class ModelSwitcher extends HTMLElement {
  constructor() {
    super();
    this.productGrid = document.querySelector(
      `#${this.getAttribute("data-grid")}`
    );
    this.status = this.querySelector(":checked").value;
    this.addEventListener("change", this.handleChangeEvent.bind(this));
    document.addEventListener(
      "modelSwitcher:changed",
      this.handleSwitchChange.bind(this)
    );
  }

  handleSwitchChange(e) {
    if (e.detail.source === this) return;
    if(e.detail.status){
        this.updateInputs(e.detail.status)
    }
  }

  handleChangeEvent(e) {
    let value = e.target.value;
    this.changeClass(value);
  }

  toggleClass() {
    if (this.productGrid) {
      this.status = this.status === "image" ? "model" : "image";
      this.productGrid.classList.toggle(
        "filter--enabled-image",
        this.status === "image"
      );
      this.productGrid.classList.toggle(
        "filter--enabled-model",
        this.status === "model"
      );
    }
  }

  changeClass(type) {
    if (type !== "image" && type !== "model") {
      console.error(`Invalid type "${type}". Use "image" or "model".`);
      return;
    }
    this.status = type;
    document.dispatchEvent(
      new CustomEvent("modelSwitcher:changed", {
        detail: { status: type },
      })
    );
    this.updateClass(type);
  }

  updateClass(type) {
    if (this.productGrid) {
      this.productGrid.classList.toggle(
        "filter--enabled-image",
        type === "image"
      );
      this.productGrid.classList.toggle(
        "filter--enabled-model",
        type === "model"
      );
    }
  }

  updateInputs(type){
    this.querySelectorAll('input[type="radio"]').forEach((radio) => {
        if (radio.value === type){
            radio.checked = true;
        } else{
            radio.checked = false;
        }
    })
  }

  connectedCallback() {}
}

window.customElements.define("model-switcher", ModelSwitcher);

/**
 * Cart drawer closes when FocusTrap treats a click as "outside" the drawer.
 * SmartSize renders its modal in the document outside <cart-drawer>, so closing
 * the size guide counted as an outside click and hid the drawer. Ignore clicks
 * that originate inside SmartSize UI (portals / known hooks).
 */
function isLikelySmartsizeUiTarget(target) {
  if (!target || typeof target.closest !== "function") return false;
  try {
    if (
      target.closest(
        [
          '[class*="smartsize"]',
          '[id*="smartsize"]',
          "[data-smartsize]",
          '[href*="smartsize"]',
        ].join(", ")
      )
    ) {
      return true;
    }
    const name = typeof target.tagName === "string" ? target.tagName.toUpperCase() : "";
    if (name === "IFRAME" && typeof target.getAttribute === "function") {
      const src = target.getAttribute("src") || target.src || "";
      if (/smartsize/i.test(String(src))) return true;
    }
  } catch {
    /* noop */
  }
  return false;
}

customElements.whenDefined("cart-drawer").then(() => {
  const CartDrawerConstructor = window.customElements.get("cart-drawer");
  if (!CartDrawerConstructor || CartDrawerConstructor.__smartsizeDrawerPatchApplied) return;
  CartDrawerConstructor.__smartsizeDrawerPatchApplied = true;

  let proto = CartDrawerConstructor.prototype;
  let inheritedHideForOutsideClickTarget;
  while (proto) {
    if (Object.prototype.hasOwnProperty.call(proto, "hideForOutsideClickTarget")) {
      inheritedHideForOutsideClickTarget = proto.hideForOutsideClickTarget;
      break;
    }
    proto = Object.getPrototypeOf(proto);
  }
  if (!inheritedHideForOutsideClickTarget) return;

  CartDrawerConstructor.prototype.hideForOutsideClickTarget = function (target) {
    if (isLikelySmartsizeUiTarget(target)) return false;
    return inheritedHideForOutsideClickTarget.call(this, target);
  };
});

//AB TESTING POSTHOG

//if (posthog.getFeatureFlag('new-plp-disable_model_switcher') === 'test') {  
 // console.log("test");
 //document.querySelector("#shopify-section-template--25172661141770__main .color-scheme").style.display = "none";
  //document.querySelector("#shopify-section-template--25172661141770__ab_test_main_collection_dAFTKV .color-scheme").style.display = "block";
//} else {
  //  console.log("control");
//}
